module.exports = __webpack_public_path__ + "img/instagram.690003da.svg";